/**
 * Product card — style 1 behaviour
 *
 * 1. Colour swatches: clicking one swaps the card image and points the
 *    quick-add form at that variant.
 * 2. Quick add: posts to /cart/add.js without leaving the page.
 * Wishlist behaviour lives in assets/wishlist.js so it can also keep the
 * header badge and dedicated wishlist page in sync.
 *
 * Delegated from the document, so cards injected later (Section Rendering
 * API, pagination, filters) work without re-initialising anything.
 */
(function () {
  /* ── Swatches ──────────────────────────────────────────────────────── */
  function selectSwatch(swatch) {
    const card = swatch.closest('.card1');
    if (!card) return;

    card.querySelectorAll('[data-card-swatch]').forEach((el) => {
      el.setAttribute('aria-pressed', String(el === swatch));
    });

    const image = card.querySelector('[data-card-image]');
    const newSrc = swatch.dataset.variantImage;
    if (image && newSrc) {
      image.src = newSrc;
      image.removeAttribute('srcset');
      // The description follows the photo. Swapping src alone left the card
      // telling a screen reader about the colour it first rendered with, which
      // is worse than saying nothing: it is confidently wrong.
      const newAlt = swatch.dataset.variantAlt;
      if (newAlt) image.alt = newAlt;
      // Disable the hover second image so the chosen colour stays visible
      card.classList.add('card1--variant-selected');
    }

    const input = card.querySelector('[data-variant-input]');
    if (input && swatch.dataset.variantId) {
      input.value = swatch.dataset.variantId;
    }

    const wishlist = card.querySelector('[data-wishlist-id]');
    if (wishlist && swatch.dataset.variantId) {
      wishlist.dataset.wishlistVariantId = swatch.dataset.variantId;
      wishlist.dataset.wishlistAvailable = swatch.dataset.variantAvailable || 'true';
      if (newSrc) wishlist.dataset.wishlistImage = newSrc;
    }

    const add = card.querySelector('[data-quick-add]');
    if (add && swatch.dataset.variantAvailable === 'false') {
      add.disabled = true;
    } else if (add) {
      add.disabled = false;
    }
  }

  /* ── Quick add ─────────────────────────────────────────────────────── */
  function quickAdd(form) {
    const button = form.querySelector('[data-quick-add]');
    const idInput = form.querySelector('[data-variant-input]');
    if (!idInput || !idInput.value) return;

    if (button) button.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
    })
      .then((response) => response.json())
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (button) {
          const label = button.querySelector('[data-add-label]');
          if (label) {
            const original = label.textContent;
            label.textContent = button.dataset.addedText || original;
            setTimeout(() => {
              label.textContent = original;
            }, 1800);
          }
        }
      })
      .catch(() => {
        // Fall back to the product page if the AJAX add fails
        const link = form.closest('.card1').querySelector('.card1__title-link');
        if (link) window.location.assign(link.href);
      })
      .finally(() => {
        if (button) button.removeAttribute('aria-busy');
      });
  }

  /* ── Delegated listeners ───────────────────────────────────────────── */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (swatch) {
      event.preventDefault();
      selectSwatch(swatch);
      return;
    }

  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-quick-add-form]');
    if (!form) return;
    event.preventDefault();
    quickAdd(form);
  });
})();
